import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoMdClose } from "react-icons/io";
import { showIconByServiceId } from "../../../helper/showIconByServiceId";
import jsPDF from "jspdf";
import "jspdf-autotable";
// import StatusChanger from "../edit/status-chenger";
import { FaEye, FaFileExcel } from "react-icons/fa";
import { Link } from "react-router-dom";
// import PaymentStatusChanger from "../edit/status-chenger/PaymentStatusChanger";
import { ability } from "../../../config/acl/ability";


const DataTable = ({ data }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const canUpdateOrderRequest = ability.can('orderRequests', 'update');

  // Handle sorting logic
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] === null || b[orderBy] === null) return 0; // Null-safe comparison
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });


  return (

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", key: "request_id" },
                { label: "User Name", key: "user_name" },
                { label: "Reseller", key: "reseller" },
                { label: "Accepted By", key: "accepted" },
                { label: "Amount", key: "amount" },
                { label: "Request", key: "request_id" },
                { label: "Payment Method", key: "payment_method" },
                { label: "Created At", key: "created_at" },
                { label: "Status", key: "status" },
                canUpdateOrderRequest ?{ label: "Review", key: "review" } : {},
              ].map((column) => (
                <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  key={column.label}
                  onClick={
                    column.key ? () => handleSort(column.key) : undefined
                  }
                  style={{ cursor: column.key ? "pointer" : "default" }}
                >
                  {column.label}
                  {column.key &&
                    (orderBy === column.key ? (
                      order === "asc" ? (
                        <span> ▲</span>
                      ) : (
                        <span> ▼</span>
                      )
                    ) : (
                      ""
                    ))}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.request_id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{item?.id}</TableCell>
                <TableCell align="center">{item?.user?.name}</TableCell>
                <TableCell align="center">{item?.admin?.name}</TableCell>
                <TableCell align="center">{item?.accepted?.name}</TableCell>
                <TableCell align="center">{item?.amount}</TableCell>
                <TableCell align="center">{item?.request_id}</TableCell>
                <TableCell align="center">{item?.payment_method}</TableCell>
                <TableCell align="center">{item?.created_at}</TableCell>
                <TableCell align="center">
                  {item?.status}
                </TableCell>
                {canUpdateOrderRequest &&
                <TableCell align="center">
                  <Link
                      to={`/OrderRequests/Edit/${item?.id}`}
                      color="inherit"
                      underline="none"
                  >
                    <FaEye className="text-[#6c757d]" />
                  </Link>
                </TableCell>
                }

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
  );
};

export default DataTable;
